import React, { useEffect, Fragment } from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';

import { fetchGetCollections } from '../../../actions/collections';

import Adaptive from '../../common/Adaptive';
import DesktopComponent from './DesktopComponent';
import MobileComponent from './MobileComponent';

const CollectionsPage = (props) => {
  const { history } = props;
  const dispatch = useDispatch();
  const collections = useSelector((state) => state.collections.data);

  useEffect(() => {
    (async function () {
      await dispatch(fetchGetCollections());
    })();
  }, []);

  const handleAddCollection = () => {
    history.push('/collections/new');
  };

  const handleCatalogTuning = () => {
    history.push('/catalog-tuning');
  };

  const handleEditCollection = (id) => {
    history.push('/collections/' + id);
  };

  const adaptiveProps = {
    handleAddCollection,
    handleCatalogTuning,
    handleEditCollection,
    collections,
  };

  return (
    <Adaptive
      DekstopComponent={DesktopComponent}
      MobileComponent={MobileComponent}
      adaptiveProps={adaptiveProps}
    />
  );
};

export default CollectionsPage;
